module.exports = __webpack_public_path__ + "static/media/wa-icon.a139de62.png";